import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-newspaper-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold tracking-tight">黑料网曝</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-md">
              一个把公开可见的讨论、路透与回应按时间收拢起来的地方。今日首发与实时快讯持续更新，随时刷新看新瓜。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                今日首发
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                实时快讯
              </span>
              <span className="rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-900">
                话题墙
              </span>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-6">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-foreground-900">
                  {column.title}
                </h4>
                <ul className="mt-3 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#cover"
                        className="text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-background-200 pt-6">
          <p className="text-xs text-foreground-500">
            本站内容均为公开信息整理与演绎排版，用于展示与浏览，不指向任何真实个人。
          </p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            © 2026 黑料网曝 · 仅供展示
          </p>
        </div>
      </div>
    </footer>
  );
}